import React from "react";

const Footer: React.FC = () => {
  return <footer className="text-center py-6 font-medium"><a
  href="https://github.com/arfazkhan"
  className="mt-4 bg-rose-100 p-2 rounded-md text-rose-600 text-center transition hover:bg-rose-200 dark:bg-slate-700/[.3] dark:text-slate-200"
>
  💻Connect with me! 
</a></footer>;
};

export default Footer;
